__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pad-tatico";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.13.3", () => (Promise.all([__webpack_require__.e(471), __webpack_require__.e(963), __webpack_require__.e(582)]).then(() => (() => (__webpack_require__(1201))))));
			register("@emotion/styled", "11.13.0", () => (Promise.all([__webpack_require__.e(963), __webpack_require__.e(664), __webpack_require__.e(33)]).then(() => (() => (__webpack_require__(9033))))));
			register("@mui/material", "6.1.6", () => (Promise.all([__webpack_require__.e(471), __webpack_require__.e(154), __webpack_require__.e(297), __webpack_require__.e(963), __webpack_require__.e(664), __webpack_require__.e(771)]).then(() => (() => (__webpack_require__(1297))))));
			register("@mui/styles", "5.10.7", () => (Promise.all([__webpack_require__.e(54), __webpack_require__.e(963), __webpack_require__.e(726)]).then(() => (() => (__webpack_require__(4054))))));
			register("i18next", "21.6.14", () => (Promise.all([__webpack_require__.e(565), __webpack_require__.e(494)]).then(() => (() => (__webpack_require__(565))))));
			register("react-dom", "17.0.1", () => (Promise.all([__webpack_require__.e(540), __webpack_require__.e(963), __webpack_require__.e(293)]).then(() => (() => (__webpack_require__(8540))))));
			register("react-i18next", "12.1.4", () => (Promise.all([__webpack_require__.e(963), __webpack_require__.e(271)]).then(() => (() => (__webpack_require__(5652))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(946), __webpack_require__.e(963), __webpack_require__.e(734)]).then(() => (() => (__webpack_require__(6946))))));
			register("react", "17.0.1", () => (__webpack_require__.e(917).then(() => (() => (__webpack_require__(5917))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};